export default "__VITE_ASSET__4bf9f668__"